let overlayData = [];

export function setOverlayData(data) {
  overlayData = data;
}

export function getOverlayData() {
  return overlayData;
}

export function pushAddToCartOverlayEvent() {
  window.dataLayer.push({
    event: 'addToCartOverlay'
  });
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/cart/helper.js
 **/